import React, { useEffect, useState } from "react";
import SlickSlider from "../SlickSlider/SlickSlider";
import icon01 from "../../assets/img/icon/choose_icon01.svg";
import icon02 from "../../assets/img/icon/choose_icon02.svg";
import icon03 from "../../assets/img/icon/choose_icon03.svg";
import icon04 from "../../assets/img/icon/choose_icon04.svg";
import WhyChooseUsItem from "./WhyChooseUsItem";
import useLang from '../../hooks/useLang';

const WhyChooseUs = () => {
  const {
    lang,
    ActiveEN,
    ActiveES
  } = useLang();

  const slickSettings = {
    dots: false,
    infinite: true,
    speed: 1000,
    autoplay: true,
    arrows: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  const slider_items = [
    {
      src: icon03,
      alt: "",
      link: "/",
      title: lang.data.Pricing.Section02.n01,
      description: lang.data.Pricing.Section02.r01,
    },
    {
      src: icon03,
      alt: "",
      link: "/",
      title: lang.data.Pricing.Section02.n02,
      description: lang.data.Pricing.Section02.r02,
    },
    {
      src: icon03,
      alt: "",
      link: "/",
      title: lang.data.Pricing.Section02.n03,
      description: lang.data.Pricing.Section02.r03,
    },
    {
      src: icon03,
      alt: "",
      link: "/",
      title: lang.data.Pricing.Section02.n03,
      description: lang.data.Pricing.Section02.r03,
    },
    // {
    //   src: icon03,
    //   alt: "",
    //   link: "/",
    //   title: "AI scores + breakdown",
    //   description: "Picks selected by artificial intelligence.",
    // },
    // {
    //   src: icon03,
    //   alt: "",
    //   link: "/",
    //   title: <>Emergency bet alerts</>,
    //   description: "Last minute golden opportunities",
    // },
    // {
    //   src: icon03,
    //   alt: "",
    //   link: "/",
    //   title: "Covering 7 sports",
    //   description: "NFL,NBA, NHL, MLB,UFC,Boxing and Tennis.",
    // },
    // {
    //   src: icon03,
    //   alt: "",
    //   link: "/",
    //   title: "3 Picks Every Days",
    //   description: "89% Win rate",
    // },
    // {
    //   src: icon01,
    //   alt: "",
    //   link: "/",
    //   title: "Lifetime free transaction",
    //   description: "Add new, trending and rare artwork to your collection.",
    // },
    // {
    //   src: icon03,
    //   alt: "",
    //   link: "/",
    //   title: <>Protect the identity</>,
    //   description: "Add new, trending and rare artwork to your collection.",
    // },
    // {
    //   src: icon04,
    //   alt: "",
    //   link: "/",
    //   title: "Sercurity & control over money",
    //   description: "Add new, trending and rare artwork to your collection.",
    // },
  ];

  const initalState = 0;
  const [count, setCount] = useState(initalState);

  useEffect(() => {
    const interval = setInterval(() => {
      setCount((old) => (old == 6 ? 0 : old + 1));
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const toMultiply = 100 / slider_items.length;

  return (
    <section className="choose-area pb-130">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6">
            <div className="section-title text-center mb-50">
              <span className="sub-title"> {lang.data.Pricing.Section04.n01} </span>
              <h2 className="title">
              {lang.data.Pricing.Section04.n02}<span>{lang.data.Pricing.Section04.n03}</span>
              </h2>
              <span className="sub-title">{lang.data.Pricing.Section04.n04}</span>
             
              {/* <h2 className="title">
              Everything included with your Full Access Pass
              </h2> */}
            </div>
          </div>
        </div>

        <div className="row choose-active">
          <SlickSlider settings={slickSettings}>
            {slider_items.map((item, index) => (
              <div key={index} className="col-lg-3">
                <WhyChooseUsItem item={item} />
              </div>
            ))}
          </SlickSlider>
        </div>

        <div className="slide-progressbar">
          <div
            style={{
              // width: `${count * toMultiply}%`,
              backgroundSize: `${count * toMultiply}% 100%`,
            }}
            className="slide-filler"
          />
        </div>

        {/* <div
          className="slide-progress"
          role="progressbar"
          aria-valuemin="0"
          aria-valuemax="100"
        >
          <span className="slider__label sr-only"></span>
        </div> */}
      </div>
    </section>
  );
};

export default WhyChooseUs;
